import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

/**
 * @about Converts the API fuel tank ratio (0–1) to the percentage used by form fields (0–100).
 * A missing value stays missing so an untouched field is not saved as an explicit zero.
 */
export function toFuelTankPercentage(fuelTankRatio: number | Nullish) {
  if (isNil(fuelTankRatio)) {
    return null;
  }

  return Math.round(fuelTankRatio * 100);
}
